module.exports = __webpack_public_path__ + "static/employers-fd89b31f38e365d014638ccec5f5821d.jpg";